<template>
  <div class=" is-fullwidth">
    <h2 class="title">Export to Planner</h2>
    
    <div class="notification is-info" v-if="loading === true">Loading orders ...</div>
        <div class="notification is-warning" v-if="loading == false && orders.length == 0">There are no orders to show</div>
        
    <table class="table is-hoverable is-fullwidth is-size-7" id="exporttable" v-if="orders.length> 0">
    	<thead>
    		<tr>
        <th>order_no</th>
   	 		<th>cust_name</th>
          <th>description</th>
          <th>fabric_type</th>
          <th></th>
          <th></th>
          <th>quantity</th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th>order_required_dt</th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th>garment_type</th>
        </tr>
    	</thead>
    	<tbody>
		   
            
            <tr v-for="order in orders" v-bind:key="order.orderID">
              
               <td >{{order.ponumber}}</td>
          <td>{{order.clientname}}</td>
          <td >{{order.garmentname}}</td>
          <td>{{ order.fabric_name}}</td>
          <td></td>
          <td></td>
          <td>{{ order.total_qty }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
           <td>{{ order.deliverydate_export }}</td>
           <td></td>
           <td></td>
           <td></td>
           <td></td>
           <td></td>
           <td></td>
           <td></td>
           <td></td>
           <td></td>
           <td></td>
           <td></td>
           <td></td>
           <td></td>
           <td>
            <span v-if="order.fully_printed==1">fully_printed</span>
            <span v-else-if="order.part_printed==1">part_printed</span>
            <span v-else>cut_sew</span>

           </td>
            
			</tr>
    	</tbody>
       
    </table>

    <button class="button is-success is-small" @click="exportXLS()" v-if="filteredOrders.length > 0 && this.exported == false">Export to CSV</button>
    <button class="button is-danger is-small" @click="refreshPage()" v-if="this.exported == true">Refresh Page</button>

   
    
  </div>
</template>

<script>


import OrderService from '@/services/OrderService.js';
//import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";
import XLSX from 'xlsx';

export default {
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      APP_URL : process.env.VUE_APP_URL,
      ranges: [],
      makeuplocations: [],
      order_by: 'deliverydate ASC',
      makeup_location_id: '',
      accessToken: '',
      exported : false
    }
  },
   methods: {
    
      async getOrders() {
        this.loading=true
        this.orders = []
        OrderService.getProductionOrdersToExportPlanner(this.accessToken, this.order_by)
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );
      },
      exportXLS() {
		 //alert("hi")
		var wb = XLSX.utils.table_to_book(document.getElementById('exporttable'), {raw:true}); 
		 XLSX.writeFile(wb, 'Planner Export.csv', {'bookType': 'csv'})

         // Update database with exported flag
         this.updatePlannerOrders()
	 },
   refreshPage() {
      this.exported = false
      this.getOrders()
   },
   updatePlannerOrders() {
        this.working = true

        var formdata = { 
            _method: 'patch',
             field_to_set: 'exported_to_planner',
             value: 1,
             order_ids: this.ordersToUpdate
        }; 

        OrderService.updateMultiOrder(this.accessToken, formdata)
        .then(() => {
            
            this.working = false
            this.exported = true
            //console.log(response)

            // Remove the orders from this screen
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
     }
    
   
    
  },
  computed : {
      filteredOrders: function () {
       
        let filteredOrders =  this.orders.filter(function(u) { 
            if(  u.checked == 1) 
            {
              return 1
            }
            else
            {
                // Always return 1
                return 1
            }
          })
          return filteredOrders
     },
     ordersToUpdate: function () {
        const ordersToUpdate = this.filteredOrders.map( (order) => order.orderID )

        return ordersToUpdate
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           
           //this.getMakeupLocations();
        });
  },
 
  mounted() {
    if (localStorage.production_allocated_makeup_location_id) {
      this.makeup_location_id = localStorage.production_allocated_makeup_location_id;
    }
    else{
      this.makeup_location_id = 5
    }
      
  },
  watch: {
    makeup_location_id: function () {
      localStorage.production_allocated_makeup_location_id = this.makeup_location_id
      if(this.accessToken != "")
      {
        this.getOrders()
      }
    },
  }
}


</script>

